<!--  -->
<template>
  <EDialog
    dialog-title="选择供应商"
    :center-dialog-visible="dialogVisible"
    popup-width="820px"
    @resetPopupData="onCancel"
    @submitPopupData="onConfirm"
  >
    <div class="dialog-content">
      <ESearch class="margin-b20"
               :data="listQuery"
               :field-list="fieldList"
               @handleFilter="handleFilter"
               @handleReset="handleReset"/>
        <div class="flex-sc margin-b20">
            <eui-btn type="primary" @click="addSupplyList" class="margin-r10">添加供应商清单</eui-btn>
            <eui-tooltip
                    class="item"
                    effect="dark"
                    content="添加供应商后可在清单中选择"
                    placement="top">
            </eui-tooltip>
        </div>

        <TableList
                ref="leftTableRef"
                :table-data="tableData"
                :table-label="tableLabel"
                :loading="tableLoading"
                maxHeight='220'
                index-show
      >
        <template #radio="{ scope: { $index: index } }">
          <el-radio v-model="radioValue" :label="index" @change="radioChange"></el-radio>
        </template>
      </TableList>
      <div class="pagination">
        <el-pagination
          :pager-count="5"
          layout="total, prev, pager, next"
          :current-page="listQuery.pageNum"
          :total="total"
          :page-size.sync="listQuery.pageSize"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
  </EDialog>
</template>

<script>
import EDialog from '@/modules/projectA/components/common/e-dialog.vue';
import TableList from '@/modules/projectA/components/common/e-table-list.vue';
import ESearch from '@/modules/projectA/components/common/e-search';
import api from '@/modules/projectA/api/order';
import {
  supplierListQuery as listQuery,
  supplierFieldList as fieldList,
  supplierLabel as tableLabel,
} from '../../common/stockOrder';

export default {
  components: {
    EDialog,
    TableList,
    ESearch,
  },
  props: {
    visible: Boolean,
  },
  data() {
    return {
      listQuery,
      total: 0,
      fieldList,
      tableLabel,
      tableData: [],
      tableLoading: false,
      radioValue: -1,
      radioData: {},
      loading: false,
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.getList();
      }
    },
  },
  methods: {
    addSupplyList() {
      this.$router.push({path: "/supplierListMaintenance"})
    },
    onCancel() {
      this.dialogVisible = false;
      this.resetRadioData();
      this.listQuery = { companyName: '', pageNum: 1, pageSize: 10 };
    },
    async getList(params) {
      try {
        this.tableLoading = true;
        const {code, data = {}} = await api.queryPageForOrder(params);
        if (code === '200') {
          const { records = [], total = 0 } = data;
          this.tableData = [...records];
          this.total = total;
        }
      } catch (error) {
        console.error(error);
        // this.tableData = [];
      } finally {
        this.tableLoading = false;
      }
    },
    radioChange(index) {
      this.radioData = this.tableData[index];
      console.log(this.radioData);
    },
    resetRadioData() {
      this.radioValue = -1;
      this.radioData = {};
    },
    handleFilter(val) {
      this.listQuery = { ...val, pageNum: 1, pageSize: 10 };
      this.getList(this.listQuery);
    },
    handleReset() {
      this.resetRadioData();
      this.listQuery = { companyName: '', pageNum: 1, pageSize: 10 };
      this.getList(this.listQuery);
    },
    handleSizeChange(size) {
      this.listQuery.pageSize = size;
      this.listQuery.pageNum = 1;
      this.getList(this.listQuery);
    },
    handleCurrentChange(num) {
      this.listQuery.pageNum = num;
      this.getList(this.listQuery);
      this.resetRadioData();
    },
    onConfirm() {
      const { companyName: supplierCompanyName, companyId: supplierCompanyId } = this.radioData;
      this.$emit('getSupplierInfo', { supplierCompanyName, supplierCompanyId });
      this.onCancel();
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-radio__label {
  display: none;
}
</style>
